// extracted by mini-css-extract-plugin
export default {"header":"UsersTable_header__AkU6+"};